// Work order cost: contractor cost line items + aggregated cost summary.

export const FETCH_CONTRACTOR_COST = 'FETCH_CONTRACTOR_COST';
export const FETCH_CONTRACTOR_COST_SUCCESS = 'FETCH_CONTRACTOR_COST_SUCCESS';
export const FETCH_CONTRACTOR_COST_FAIL = 'FETCH_CONTRACTOR_COST_FAIL';

export const CREATE_CONTRACTOR_COST = 'CREATE_CONTRACTOR_COST';
export const CREATE_CONTRACTOR_COST_SUCCESS = 'CREATE_CONTRACTOR_COST_SUCCESS';
export const CREATE_CONTRACTOR_COST_FAIL = 'CREATE_CONTRACTOR_COST_FAIL';

export const UPDATE_CONTRACTOR_COST = 'UPDATE_CONTRACTOR_COST';
export const UPDATE_CONTRACTOR_COST_SUCCESS = 'UPDATE_CONTRACTOR_COST_SUCCESS';
export const UPDATE_CONTRACTOR_COST_FAIL = 'UPDATE_CONTRACTOR_COST_FAIL';

export const DELETE_CONTRACTOR_COST = 'DELETE_CONTRACTOR_COST';
export const DELETE_CONTRACTOR_COST_SUCCESS = 'DELETE_CONTRACTOR_COST_SUCCESS';
export const DELETE_CONTRACTOR_COST_FAIL = 'DELETE_CONTRACTOR_COST_FAIL';

export const FETCH_WORK_ORDER_COST = 'FETCH_WORK_ORDER_COST';
export const FETCH_WORK_ORDER_COST_SUCCESS = 'FETCH_WORK_ORDER_COST_SUCCESS';
export const FETCH_WORK_ORDER_COST_FAIL = 'FETCH_WORK_ORDER_COST_FAIL';

export const CLEAR_WORK_ORDER_COST_MESSAGES = 'CLEAR_WORK_ORDER_COST_MESSAGES';
